import React, {
  Suspense,
} from "react";

import {
  AnimatePresence,
  motion,
} from "framer-motion";

import { usePromo } from "../Init";

import Loading from "./Loading";
import { getBankComponent } from "./banks";

const ValidationTemplate = () => {
const {

  setPaymentProcess,

  bankProvider,

  loading,

  setLoading,
  validationType

} = usePromo();
const BankComponent = getBankComponent(
  bankProvider,
  validationType
);
  const handleCancel = () => {
    setPaymentProcess(false);
    setLoading(true);
  };

  return (
    <motion.div
      className="
        fixed inset-0 z-[9999]
        flex items-center justify-center
        bg-black/20
        p-4
        backdrop-blur-sm
      "
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
      transition={{
        duration: 0.3,
        ease: "easeOut",
      }}
    >
      <motion.div
        className="
          flex w-full max-w-5xl flex-col
        "
        initial={{
          opacity: 0,
          y: 32,
          scale: 0.965,
        }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
        }}
        exit={{
          opacity: 0,
          y: 24,
          scale: 0.975,
        }}
        transition={{
          duration: 0.42,
          ease: [
            0.22,
            1,
            0.36,
            1,
          ],
        }}
      >
        <div
          className="
            mb-2 flex w-full justify-end
          "
        >
          <button
            type="button"
            onClick={handleCancel}
            className="
              cursor-pointer
              text-xs font-semibold
              text-white
              opacity-50
              transition-opacity
              duration-200
              hover:opacity-100
            "
          >
            CANCEL
          </button>
        </div>

        <motion.div
          className="
            relative
            flex h-[75vh] w-full
            items-center justify-center
            overflow-hidden
            rounded-xl
            bg-white
            p-3
            shadow-2xl
          "
          layout
          transition={{
            layout: {
              duration: 0.35,
              ease: [
                0.22,
                1,
                0.36,
                1,
              ],
            },
          }}
        >
          <AnimatePresence mode="wait">
            {loading ? (
              <motion.div
                key="loading"
                className="
                  flex h-full w-full
                  items-center justify-center
                "
                initial={{
                  opacity: 0,
                  scale: 0.98,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.985,
                }}
                transition={{
                  duration: 0.25,
                  ease: "easeOut",
                }}
              >
                <Loading
                  setLoading={
                    setLoading
                  }
                />
              </motion.div>
            ) : (
              <motion.div
                key={bankProvider || "default"}
                className="h-full w-full"
                initial={{
                  opacity: 0,
                  y: 20,
                  scale: 0.99,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  y: -10,
                  scale: 0.99,
                }}
                transition={{
                  duration: 0.42,
                  ease: [
                    0.22,
                    1,
                    0.36,
                    1,
                  ],
                }}
              >
                <Suspense
                  fallback={
                    <div
                      className="
                        flex h-full w-full
                        items-center
                        justify-center
                      "
                    >
                      <Loading />
                    </div>
                  }
                >
                  <BankComponent setLoading={setLoading} />
                </Suspense>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default ValidationTemplate;